import { useEffect, useRef } from 'react';

/** Subscribes to window `keydown` once and always invokes the latest handler. */
export function useWindowKeydown(handler: (event: KeyboardEvent) => void): void {
  const latest = useRef(handler);
  latest.current = handler;
  useEffect(() => {
    const listener = (event: KeyboardEvent) => latest.current(event);
    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, []);
}
